exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  list-style: none;\n  padding: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/group-members/group-members.component.css
// module id = 850
// module chunks = 0